import React, { useContext } from 'react';
import { usePaymentsComparisonModal } from './UsePaymentsComparisonModal';

type PaymentsComparisonModalContext = ReturnType<typeof usePaymentsComparisonModal>;

const initialContext: PaymentsComparisonModalContext = {
  title: 'Pricing options that work for your business',
  payInFullToggleText: 'Pay in full',
  payMonthlyToggleText: 'Pay monthly',
  compareLinkText: 'See benefits',
  monthlyOptionHeading: 'Monthly',
  upfrontOptionHeading: 'In full',
  sideHeadingOptionItems: [],
  monthlyOptionItems: [],
  upfrontOptionItems: [],
  disclaimerItems: [],
};

const PaymentsComparisonModal = React.createContext<PaymentsComparisonModalContext>(initialContext);
PaymentsComparisonModal.displayName = 'PricingComparisonModals';

export const usePaymentsComparisonModalContext = () => useContext(PaymentsComparisonModal);

export const PaymentsComparisonModalProvider: React.FC = ({ children }) => {
  return (
    <PaymentsComparisonModal.Provider value={usePaymentsComparisonModal()}>
      {children}
    </PaymentsComparisonModal.Provider>
  );
};
